import { render } from "./Demo.vue?vue&type=template&id=3fe5cce6&scoped=true&ts=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"

import "./Demo.vue?vue&type=style&index=0&id=3fe5cce6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe5cce6"]])

export default __exports__